"use strict";

define(['app', 'jquery', './base', './../translationsUtils/translations'], function (app, $, Helper, translations) {
  var t = translations.t;
  return Helper.extend({
    ui: {
      row: '.js-unread-row'
    },
    options: {
      url: ''
    },
    parseOverviewCounters: function parseOverviewCounters(obj) {
      for (var index in obj) {
        if (typeof obj[index] === 'undefined') continue;
        var topicCount = +obj[index].topicCount;
        var postCount = +obj[index].postCount;
        var postRow = $(this.ui.row).filter('[data-value=' + index + ']');
        var unreadPostCounter = $(postRow).find('.js-post-new');
        var unreadTopicCounter;

        if (topicCount) {
          unreadTopicCounter = $(postRow).find('.js-topic-new');
          unreadTopicCounter.removeClass('is-hidden').html('(' + t('Forum', 'forumList.meta.counter.topic.user.new', {
            n: topicCount
          }) + ')');
        }

        if (postCount) {
          unreadPostCounter.attr('href', '/topic/firstNewPostRedirect?topicId=' + index).removeClass('is-hidden').html('(' + t('Forum', 'forumList.meta.counter.post.user.new', {
            n: postCount
          }) + ')');
        }

        if (this.options.icons) {
          postRow.addClass(obj[index].class);
        }
      }
    },
    getCounters: function getCounters(options) {
      var self = this;
      var data = $(this.ui.row);
      var topicIds = $.map(data, function (elem) {
        if ($(elem).attr('data-value') !== 'undefined') {
          return $(elem).attr('data-value');
        }
      });
      var url = options.url + '?topicIds=' + JSON.stringify(topicIds);
      app.$.ajax({
        url: url,
        success: function success(unreadPostData) {
          if (!unreadPostData) return;
          if (unreadPostData) self.parseOverviewCounters(unreadPostData);
        }
      });
    },
    initialize: function initialize() {
      translations.addTranslationDict(this.options.translations);
      this.getCounters(this.options);
    }
  });
});